export default __webpack_public_path__ + "static/media/third-section.41ae14f2.jpeg";